<fc-icon  *ngIf="icon" [src]="icon"></fc-icon>
<img *ngIf="imageSrc && !icon" [src]="imageSrc" loading="lazy">